import React from 'react';

import { textWrap } from 'Core/Utils';

class Headline extends React.Component {
  constructor (props) {
    super(props);
  }

  prepareText (text) {
    return !text || !text.length
      ? null
      : text
        .trim()
        .split('\n')
        .filter(line => line.length)
        .map(line => (
          <div key={line} className="bloc">
            <span>{line}</span>
          </div>
        )
    );
  }

  render () {
    let { text, className, wrap, align = 'center' } = this.props;
    className = 'Headline' + (className ? ' ' + className : '');
    wrap = (wrap && typeof wrap !== 'number' ? 12 : (wrap ? wrap : 0));
    text = this.prepareText(wrap ? textWrap(text, wrap) : text);
    return (
      <h1 className={className} style={{ textAlign: align }}>{text}</h1>
    );
  }
};

export default Headline;



// WEBPACK FOOTER //
// ./client/Core/Components/Headline.jsx